import { signupTracker } from '@mobi/account/Common/Analytics'
import { post, queryKeys, SignUpUrl } from '@mobi/account/Utils'
import { ApplicationSubmitRequest, ApplicationSubmitResponse } from '@mobi/api-types/index'

import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getSignUpState } from '../Store'

export const useApplicationSubmit = (applicationNumber: number) => {
  const signUpState = useSelector(getSignUpState)

  const { mutate: applicationSubmit, status: applicationSubmitStatus } = useMutation<
    ApplicationSubmitResponse,
    Error,
    ApplicationSubmitRequest
  >({
    mutationKey: [queryKeys.signupApplicationSubmit, applicationNumber],
    mutationFn: (req): Promise<ApplicationSubmitResponse> => {
      return post(SignUpUrl.applicationSubmit(applicationNumber.toString()), req)
    },

    onError: error => {
      signupTracker({
        interaction_type: 'Sign Up Error',
        signUpFlow: signUpState.isVerificationAccount ? 'ID Verification' : 'Standard',
        message: error.message,
      })
    },
  })
  return { applicationSubmit, applicationSubmitStatus }
}
